/**
 * Token storage and management
 *
 * Stores JWT token in localStorage and provides helper to get auth headers.
 */

const TOKEN_KEY = 'auth-token'

/**
 * Store the auth token
 */
export function setToken(token: string): void {
	localStorage.setItem(TOKEN_KEY, token)
}

/**
 * Get the stored auth token
 */
export function getToken(): string | null {
	return localStorage.getItem(TOKEN_KEY)
}

/**
 * Remove the auth token
 */
export function removeToken(): void {
	localStorage.removeItem(TOKEN_KEY)
}

/**
 * Get Authorization header if token exists
 */
export function getAuthHeaders(): HeadersInit {
	const token = getToken()
	if (token) {
		return { Authorization: `Bearer ${token}` }
	}
	return {}
}

/**
 * Check if user has a stored token
 */
export function hasToken(): boolean {
	return getToken() !== null
}
